import { render, staticRenderFns } from "./BudgetSubCategory.vue?vue&type=template&id=2d1ceb8a&"
import script from "./BudgetSubCategory.vue?vue&type=script&lang=js&"
export * from "./BudgetSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports